<template>
  <div class="hello">

    <menupicker value="registration">{{ active }}</menupicker>
    <h1>{{ msg }}</h1>
    <div>
      <p><a href="https://s3-us-west-2.amazonaws.com/gmbch-forms/GrandMesaBackCountryHorsemen.pdf" target="_blank">Download our membership registration form</a> and our <a href="https://s3-us-west-2.amazonaws.com/gmbch-forms/GrandMesaBackCountryHorsemenLiabilityRelease.pdf" target="_blank"> liability release form</a>. Complete these and return with membership fee.</p>
    </div>
  </div>

</template>

<script>
  import Vue from 'vue';
  import Vuex from 'vuex';
  import Vuetify from 'vuetify';
  import MenuPicker from './MenuPicker.vue';

  Vue.use(Vuetify);
  Vue.use(Vuex);
  Vue.component('menupicker', MenuPicker);

export default {
  name: 'Registration',
  data () {
    return {
      active: 'registration',
      msg: 'Membership Registration Form',
    }
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1, h2 {
  font-weight: normal;
  font-size: large;
}
ul .link {
  list-style-type: none;
  padding: 0;
}
li .link {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}

  .bodycenter {
    font-family: "Adobe Devanagari";
    font-size: large;
    font-weight: bold;
    width: 75%;
    text-align: left;
  }

  .center {
    margin: auto;
    margin-top: 5px;
    width: 50%;
    padding: 10px;
  }

.green {
  border: 3px solid green;
}

.normalli {
    margin-bottom: 1em;
  }

  .rcorners1 {
    border-radius: 25px;
    padding: 5px;
  }

  .subinfo {
    margin: 0;
  }

</style>


// WEBPACK FOOTER //
// src/components/Registration.vue